import { datadogLogs } from '@datadog/browser-logs';
import { datadogClient } from './clients';
import { Storage, getDataForSettingIdentity } from 'services';

export function initTrackingContext() {
  // If name (t-id) and org (t-org) saved in line 16,
  // get them from storage to improve start speed
  if (Storage.get('t-id') && Storage.get('t-org')) {
    setIdentity(atob(Storage.get('t-id') as string), atob(Storage.get('t-org') as string));
  } else {
    getDataForSettingIdentity.then((response) => {
      const email = response.data.me.userProfile.email;
      const organizationName = response.data.me.userProfile.organization.name;

      // Save email/org for faster use in initLogging().
      // Encoded to make it a tiny bit more secure (by obscurity)
      Storage.set('t-id', btoa(email));
      Storage.set('t-org', btoa(organizationName));

      setIdentity(email, organizationName);
    });
  }
}

function setIdentity(email: string, organizationName: string) {
  datadogClient.addRumGlobalContext('usr', {
    email: email,
    org: organizationName,
  });
  datadogLogs.setLoggerGlobalContext({
    email: email,
    org: organizationName,
  });
}
